import { queryGetReport } from '../Queries';

const convertToAPIBody = (facilityId, filterValues, format) => {
  const data = {};
  data.format = format;
  data.params = {};
  data.params.facilityId = facilityId;

  const {
    reportType,
    rateTypes,
    payorId,
    payorBillingName,
    invoiceStartDate,
    invoiceEndDate,
    parkingPeriodStartMonth,
    parkingPeriodStartYear,
    parkingPeriodEndMonth,
    parkingPeriodEndYear
  } = filterValues;

  const reportTypesFiltered = rateTypes.map(rateType => rateType.value);

  switch (reportType) {
    case 'INVOICE_REPORT':
      data.report = 'InvoiceReport';
      data.params.rateType = reportTypesFiltered;
      break;
    case 'DETAIL_REPORT':
      data.report = 'InvoiceMonthlyReport';
      data.params.rateType = reportTypesFiltered;
      break;
    case 'VALIDATION_REPORT':
      data.report = 'InvoiceValidationReport';
      data.params.rateType = reportTypesFiltered;
      break;
    case 'CARRYOVER_REPORT':
      data.report = 'CarryoverInvoiceReport';
      data.params.rateType = reportTypesFiltered;
      break;
    case 'ADJUSTMENT_REPORT':
      data.report = 'InvoiceAdjustmentReport';
      data.params.rateType = reportTypesFiltered;
      break;
    case 'RATE_REPORT':
      data.report = 'SummaryByRateReport';
      break;
    case 'RATE_AMOUNT_REPORT':
      data.report = 'SummaryByRateAmountReport';
      break;
    default:
      data.params.rateType = reportTypesFiltered.filter(rateType => rateType !== 'VALIDATION_OTHER');
  }

  if (reportType !== 'CARRYOVER_REPORT') {
    // we wrap these numerical values in isNaN and parseInt as to
    // prevent zeros being interpreted as falsy/null values
    data.params.parkingPeriodStartMonth = isNaN(parseInt(parkingPeriodStartMonth)) ? null : `${parkingPeriodStartMonth}`;
    data.params.parkingPeriodEndMonth = isNaN(parseInt(parkingPeriodEndMonth)) ? null : `${parkingPeriodEndMonth}`;
    data.params.parkingPeriodStartYear = isNaN(parseInt(parkingPeriodStartYear)) ? null : `${parkingPeriodStartYear}`;
    data.params.parkingPeriodEndYear = isNaN(parseInt(parkingPeriodEndYear)) ? null : `${parkingPeriodEndYear}`;
  }

  data.params.invoiceStartDate = invoiceStartDate ? invoiceStartDate.format("YYYY-MM-DD") : null;
  data.params.invoiceEndDate = invoiceEndDate ? invoiceEndDate.format("YYYY-MM-DD") : null;
  data.params.subscriberId = payorId;
  data.params.subscriptionName = payorBillingName;

  // remove nulls
  Object.keys(data.params).forEach(key => {
    if (data.params[key] === null) {
      delete data.params[key];
    }
  });

  return data;
}

export default {
  initialFilters: {
    reportType: '',
    rateTypes: [],
    payorId: '',
    payorBillingName: '',
    invoiceStartDate: null,
    invoiceEndDate: null,
    parkingPeriodStartMonth: null,
    parkingPeriodStartYear: null,
    parkingPeriodEndMonth: null,
    parkingPeriodEndYear: null,
  },
  reportQuery: (facilityId, filterValues, format = 'csv') => {
    const data = convertToAPIBody(facilityId, filterValues, format);
    return queryGetReport(data);
  },
  fileName: 'invoice_report.csv',
}